// The ways into a room, as links. The ONE that gets shared is `room`: it
// opens on a screen that asks whether this is a player's phone or the
// shared table, so a friend gets a single link and opens it on both (Matt,
// 2026-10-20: "I'll just share this single link with them and I will say,
// open this link on both your computer and your phone"). `join` and `table`
// still work, and the TV's QR code is still a straight `join` - whoever
// scans it is holding a phone.

export const roomLinks = (code, origin = window.location.origin) => ({
  room: `${origin}/?room=${code}`,
  join: `${origin}/?join=${code}`,
  table: `${origin}/?table=${code}`,
});

export const roomLinksMessage = (code, origin) => {
  const { room } = roomLinks(code, origin);
  return `Join our commonwealth - open this on your phone and on your TV or laptop: ${room}`;
};

// Share sheet where there is one (iOS, Android), clipboard otherwise.
// Resolves 'shared' | 'copied'; rejects only if both are unavailable.
export const shareRoomLinks = async (code) => {
  const text = roomLinksMessage(code);
  if (navigator.share) {
    await navigator.share({ title: 'Commonwealth', text });
    return 'shared';
  }
  await navigator.clipboard.writeText(text);
  return 'copied';
};

// Just the link, for the TV's copy button.
export const copyRoomLink = (code) => navigator.clipboard.writeText(roomLinks(code).room);
